import React from 'react';
import Utils from '../utils';

const { Session } = Utils;

export const LearningCenterArticleLink = ({ linkText, stamps }) => {
	return (
		<div className="common-article-external-link">
			<a
				className="article-link"
				role="button"
				tabIndex="0"
				onClick={() =>
					window.open(`https://help.stamps.com/hc/en-us/articles/${stamps}`)
				}
			>
				{linkText}
			</a>
			<span className="external-link-nav" />
		</div>
	);
};
